import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import RoleIcon from "../../Icons/RoleIcon";
import APIS from "../../constant/EndPoint";
import useDeleteHook from "../../customHooks/useDeleteHook";
const RoleListComponent = loadable(
  () => import("../../components/Role/RoleList")
);

const RoleList = () => {
  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["roles"],
  });
  const handleDelete = async (
    id: any,
    setOpenDeletePopup: any,
    setError: any
  ) => {
    const url = `${APIS.GROUP}${id}/`;
    try {
      const res = await mutateAsync({ url, setError });
      if (res?.status === 200 || res?.status === 204) {
        setOpenDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <RoleIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Roles</span>
      </div>
      <RoleListComponent handleDelete={handleDelete} isLoading={isLoading} />
    </>
  );
};

export default RoleList;
